import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const data = [{
  name: 'Morning',
  adherence: 95,
  target: 100
}, {
  name: 'Noon',
  adherence: 88,
  target: 100
}, {
  name: 'Evening',
  adherence: 92,
  target: 100
}, {
  name: 'Night',
  adherence: 97,
  target: 100
}];
export const MedicationAdherenceChart: React.FC = () => {
  return <ResponsiveContainer width="100%" height="100%" data-id="element-37">
      <BarChart data={data} margin={{
      top: 5,
      right: 30,
      left: 20,
      bottom: 5
    }} data-id="element-38">
        <CartesianGrid strokeDasharray="3 3" data-id="element-39" />
        <XAxis dataKey="name" data-id="element-40" />
        <YAxis domain={[0, 100]} data-id="element-41" />
        <Tooltip data-id="element-42" />
        <Legend data-id="element-43" />
        <Bar dataKey="adherence" fill="#1f58b0" data-id="element-44" />
        <Bar dataKey="target" fill="#f6d052" data-id="element-45" />
      </BarChart>
    </ResponsiveContainer>;
};